import _ from 'lodash'
import { UUID } from '@/plugins/common'
import ButtonCondition from './buttonConditions'

export default class Button {
  constructor (args = {}) {
    const defaults = {
      id: UUID.create(),
      isCustom: true,
      name: '',
      type: '',
      targetType: 'form',
      targetId: '',
      restrictiveCondition: '',
      tipsEnable: false,
      tip: '',
      templateName: '',
      // 电子合同按钮属性
      setting: {},
      // 禁用条件
      conditions: [],
      //  显示方式
      showFlag: 'fold',
      //  筛选项计算列表
      filterItems: {},
      // 导入类型
      importType: 'increase'
    }
    if (args.conditions) {
      args.conditions = args.conditions.map(m => {
        return new ButtonCondition(m)
      })
    }
    _.defaults(this, args, defaults)
  }
}



// WEBPACK FOOTER //
// ./src/store/report/button.js